if (typeof currencyConverter != 'undefined' && typeof currencyConverter._current() != 'undefined') {
  window.jQuery(document).on('Searchanise.ResultsUpdated', function(){
    window.jQuery('span.snize-price.money').each(function(index,el){
      value = el.textContent.replace(/\.[0-9]+$/g, '');
      window.jQuery(el).attr('data-currency-original', value);
    });
    currencyConverter._current();
  });
}


document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

    $(document).on('Searchanise.ResultsUpdated', function(){

      $('#snize_results li.snize-product').each(function(index,el) {
        var product = $(el).data('snize_item_data');

        if (product.metafield_0f3ec7e756eb3c40b254b5a15e118863) {
          var rrp = product.metafield_0f3ec7e756eb3c40b254b5a15e118863 / 100;
          var p = Math.round(product.price / rrp * 100);
          var percentageOff = 100 - p;

          if (percentageOff > 0) {

            var rrpText = 'RRP At New ' + Searchanise.GetWidgets().formatPrice(rrp);
            var rrpSave = 'Save ' + percentageOff + '%';

            if (!$(el).find('span.snize-rrp-custom').length) {

              $(el).find('span.snize-title').after(
                '<span class="snize-description snize-rrp-custom" style="max-height: 1.4em; -webkit-line-clamp: 1;">' + rrpText + '</span>'
              );
              // START added by Searchanise support --ap
              $('.snize-product-label.top-right', el).css('top', '35px');
              $('div.snize-thumbnail-wrapper', el).append(
                '<div class="snize-product-label snize-custom-percentage top-right" style="display: block;background: #ff575f;border-radius: 20px;font-size: 12px;padding: 5px 10px;">' + rrpSave + '</div>'
              );
              // END added by Searchanise support --ap
            }
          }
        }
      });

    });
  })(window.Searchanise.$);
});